import { ReactNode } from "react";

const redacted = process.env["REACT_APP_RC_360_REDACTED"] === "true";

export default function Redacted(props: { children: ReactNode }) {
  return (
    <span className={redacted ? "redacted" : undefined}>{props.children}</span>
  );
}
